// Simple in-memory notification helper. Components can import `notify` to push messages.
const listeners = new Set();

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function notify(type, message) {
  for (const fn of listeners) {
    try { fn({ type, message, id: Date.now() + Math.random() }); } catch (e) { /* ignore */ }
  }
}

const notifier = { subscribe, notify };
export default notifier;
